import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss'
import classNames from 'classnames'
import { connect } from 'react-redux';

import { setFormData as setStandardFormData } from '../../WarrantyStandardForm/redux/actions';
import { setFormData as setTransferFormData } from '../../WarrantyTransferForm/redux/actions';

const mapStateToProps = state => (
  {
    formData: state.formData,
  }
);

const TextInput = ({ value, htmlAttributes, invalidInput, icon, setStandardFormData, setTransferFormData, formData, fieldKey }) => {
  const { placeholder, className, ...otherHtmlAttributes } = htmlAttributes;
  const actualValue = formData[fieldKey]; // we really shouldn't be passing value, this comes from formData always
  const handleChange = (newValue, keyName) => {
    const pattern = htmlAttributes.pattern
    if (formData.formName == "WarrantyStandard") {
      if (!pattern) {
        setStandardFormData({ [keyName]: newValue })
        return;
      }
      const regexp = new RegExp(`^${pattern}$`)
      if (regexp.test(newValue)) {
        setStandardFormData({ [fieldKey]: newValue.replace(`^${pattern}$`) })
      }
      if (regexp.test(newValue) && htmlAttributes.isphoneinput) {
        setStandardFormData({[keyName]: newValue.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")});
      }
    } else {
      if (!pattern) {
        setTransferFormData({ [keyName]: newValue })
        return;
      }

      const regexp = new RegExp(`^${pattern}$`)
      if (regexp.test(newValue)) {
        setTransferFormData({ [fieldKey]: newValue.replace(`^${pattern}$`) })
      }

      if (regexp.test(newValue) && htmlAttributes.isphoneinput) {
        setTransferFormData({[keyName]: newValue.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")});
      }
    }
  }
  return (
    <div className={className}>
      <div className={invalidInput ? styles.floatingLabelError : styles.floatingLabel}>
        {icon && <div className={styles.iconContainer}>{icon}</div>}
        <input
          type={"text"}
          onChange={(event) => handleChange(event.target.value, fieldKey)}
          required
          className={classNames(styles.text, {[styles.withIcon]: !!icon})}
          value={actualValue}
          id={otherHtmlAttributes.id || placeholder}
          {...otherHtmlAttributes}
        />
        {placeholder && <label htmlFor={placeholder}>{placeholder}</label>}
      </div>
    </div>
  )
}

TextInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  htmlAttributes: PropTypes.object,
  invalidInput: PropTypes.bool,
  icon: PropTypes.node
};

TextInput.defaultProps = {
  htmlAttributes: {}
};

const mapDispatchToProps = dispatch => (
  {
    setStandardFormData: (hash) => dispatch(setStandardFormData(hash)),
    setTransferFormData: (hash) => dispatch(setTransferFormData(hash))
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TextInput);
